var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('vue-phone-number-input',{attrs:{"no-use-browser-locale":"","translations":_vm.i18n},on:{"update":_vm.emitResult},model:{value:(_vm.phoneNumberEdit),callback:function ($$v) {_vm.phoneNumberEdit=$$v},expression:"phoneNumberEdit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }